import { useState } from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "./S6_ActivationStep2.module.scss";
import { LinearProgressBarCust, ButtonCust } from "../../../widgets";
import { NewNumberModal } from "./NewNumberModal";
import {
  gaCategory,
  gaEvents,
  gaScreenNames,
} from "../../../../Types/GoogleAnalytics";
import CurrentNumberForm from "./CurrentNumberForm";
import PinHelperText from "./PinHelperText";
import AccountPinHelperText from "./AccountPinHelperText";
import Config from "../../../../config/env.config.json";
import { InternalBanner } from "../../../common";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { gtmTagManager } from "../../../../utils";

const T6ActivationStep2 = (props: any) => {
  const {
    currentLine,
    content,
    GAAndFBEventsHandler,
    operators,
    currentOperator,
    zipcodeCheckHandler,
    setOpenSupportDialog,
    clickHandlerForPortNum,
    currentNum,
    handleBack,
    newNumHandler,
  } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const { sp2_title, c_num, step_txt, num_pref, click_here_txt, help_txt } =
    content;
  return (
    <>
      {/* <InternalBanner
        // key={key}
        pageName={"MyAccount"}
        apiEndPoint={"myAccBanner"}
        type={"internal"}
      /> */}
      <KeyboardBackspaceIcon
        onClick={handleBack}
        fontSize="large"
        sx={{
          display: { xs: "block", sm: "none" },
          position: "absolute",
          top: "21.5px",
          left: "20px",
          color: "var(--internal_back_arrow_color, var(--white))",
        }}
      />
      <Box
        sx={{
          cursor: "pointer",
          width: "18px",
          height: "18px",
          zIndex: "100",
          left: "0",
          position: "absolute",
          ml: { md: "30px", sm: "25px", xs: "25px" },
          mt: { md: "60px" },
          display: { xs: "none", sm: "inline-block" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "18px",
            height: "18px",
            position: "absolute",
            left: "3rem",
            alignItems: "center",
          }}
          onClick={handleBack}
        >
          <ArrowBackIosIcon sx={{ width: "18px", fontSize: "1.125re," }} />
          <Box
            sx={{
              fontFamily: "var(--font_family_Medium)",
              fontWeight: "var(--font_weight_1)",
              fontSize: "18px",
              lineHeight: "30px",
            }}
          >
            Back
          </Box>
        </Box>
      </Box>
      <KeyboardBackspaceIcon
        onClick={handleBack}
        fontSize="large"
        sx={{
          display: { xs: "block", sm: "none" },
          position: "absolute",
          top: "91.5px",
          left: "20px",
          color: "var(--internal_back_arrow_color, var(--white))",
        }}
      />
      <Box sx={{ background: "var(--lightgrey)" }}>
        {!currentNum ? (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                minHeight: "88vh",
                width: { xs: "92%", sm: "100%" },
                mx: "auto",
              }}
            >
              <Paper
                sx={{
                  width: { sm: "724px" },
                  maxHeight: { xs: content?.du_w_nn ? "550px" : "500px" },
                  mt: { xs: "40px", sm: "60px" },
                  mb: { md: "60px" },
                  boxShadow: { xs: "unset !important" },
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    p: { xs: "25px 0px" },
                    width: "100%",
                  }}
                >
                  {/* <Box
                    component="img"
                    alt={"circular_loader"}
                    src={content?.numberpre_icon?.data?.attributes?.url}
                    sx={{ paddingRight: "16px" }}
                  /> */}
                  <Typography
                    sx={{
                      fontSize: { xs: "18px", sm: "24px" },
                      fontFamily: "var(--font_family_Bold)",
                      textAlign: "center",
                      fontWeight: "var(--font_weight_4)",
                      color: "var(--black)",
                      lineHeight: { xs: "30px", sm: "36px" },
                    }}
                  >
                    {currentNum ? c_num.title : sp2_title}
                  </Typography>
                </Box>
                <Box sx={{ width: "100%", textAlign: "center" }}>
                  <Divider
                    style={{ border: "1px solid var(--lightgrey_6)" }}
                  ></Divider>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "var(--font_weight_2)",
                      lineHeight: "26px",
                      fontFamily: "var(--font_family_Semibold)",
                      my: { xs: "12px", sm: "25px" },
                      color: "var(--text_color)",
                    }}
                  >
                    {!currentLine?.esim && content?.step_txt_next
                      ? content?.step_txt_next
                      : content?.step_txt}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "var(--font_weight_2)",
                      lineHeight: "30px",
                      fontFamily: "var(--font_family_Semibold)",
                      mb: { xs: "12px", sm: "26px" },
                      color: "var(--text_color)",
                    }}
                  >
                    {num_pref?.desc}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    textAlign: "center",
                    width: { xs: content?.du_w_nn ? "100%" : "60%", sm: "60%" },
                    margin: "0 auto 26px auto",
                  }}
                >
                  <ButtonCust
                    variantType={Config.PRIMARY_BUTTON_TYPE}
                    sx={{
                      width: { xs: "250px", sm: "250px", md: "250px" },
                      // height: { md: "50px !important" },
                      mb: { xs: "12px", sm: "26px" },
                    }}
                    onClick={() => {
                      clickHandlerForPortNum();
                      GAAndFBEventsHandler(
                        gaCategory.activation,
                        num_pref?.c_num_btn
                      );
                      gtmTagManager({
                        event: gaEvents?.portInInitiated,
                        screen_name: gaScreenNames?.activation,
                      });
                    }}
                  >
                    {num_pref?.c_num_btn}
                  </ButtonCust>
                  <Box>
                    <span
                      className={styles.card_description}
                      style={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "14px",
                        fontWeight: "var(--font_weight_0)",
                        lineHeight: "26px",
                        color: "var(--text_color)",
                        // mb: { xs: "12px", sm: "30px" },
                      }}
                    >
                      {num_pref?.txt1}&nbsp;
                    </span>
                    <span
                      style={{
                        color: "var(--primary_color)",
                        cursor: "pointer",
                        textDecoration: props?.content?.whh_new_tab
                          ? "none"
                          : "underline",
                        fontFamily: "var(--font_family_Semibold)",
                        fontSize: "14px",
                        fontWeight: "var(--font_weight_2)",
                        lineHeight: "26px",
                      }}
                      onClick={() => window.open(content?.click_link, "_blank")}
                    >
                      {click_here_txt}&nbsp;
                    </span>
                    <span
                      className={styles.card_description}
                      style={{
                        color: "var(--text_color)",
                        fontSize: "14px",
                        fontWeight: "var(--font_weight_0)",
                        lineHeight: "26px",
                        fontFamily: "var(--font_family_Regular)",
                      }}
                    >
                      {help_txt}
                    </span>
                  </Box>
                </Box>
                {content?.du_w_nn ? (
                  <Typography
                    sx={{
                      color: "var(--text_color)",
                      fontSize: "16px",
                      fontWeight: "var(--font_weight_2)",
                      lineHeight: "20px",
                      fontFamily: "var(--font_family_Semibold)",
                      mb: "20px",
                    }}
                  >
                    {content?.du_w_nn}
                  </Typography>
                ) : null}
                <Box mb="16px" sx={{ textAlign: "center" }}>
                  <ButtonCust
                    variantType={Config.PRIMARY_BUTTON_TYPE}
                    sx={{
                      width: { xs: "250px", sm: "250px", md: "250px" },
                      // height: { md: "50px !important" },
                      mb: { xs: "12px", sm: "25px" },
                    }}
                    onClick={() => {
                      setOpenDialog(true);
                      newNumHandler(),
                        GAAndFBEventsHandler(
                          gaCategory.activation,
                          num_pref?.new_num_btn
                        );
                      gtmTagManager({
                        event: gaEvents?.getNewNumber,
                        screen_name: gaScreenNames?.activation,
                      });
                    }}
                  >
                    {num_pref?.new_num_btn}
                  </ButtonCust>
                  <Typography
                    className={styles.card_description}
                    sx={{
                      fontSize: "14px",
                      fontWeight: "var(--font_weight_0)",
                      lineHeight: "26px",
                      fontFamily: "var(--font_family_Regular)",
                      mb: { xs: "12px", sm: "10px" },
                      width: { xs: "80%", sm: "60%" },
                      margin: "0 auto",
                      color: "var(--text_color)",
                    }}
                  >
                    {num_pref?.txt2_sec
                      ? currentLine?.isPrimary
                        ? num_pref?.txt2
                        : num_pref?.txt2_sec
                      : num_pref?.txt2}
                  </Typography>
                </Box>
              </Paper>
            </Box>
          </>
        ) : (
          <CurrentNumberForm styles={styles} {...props} />
        )}
      </Box>
      <Box sx={{ background: "var(--lightgrey)" }}>
        {currentNum && !currentOperator?.acctNumMsg && (
          <Box
            width={{
              xs: "90%",
              sm: "724px",
              margin: content?.du_w_nn ? "0px auto 10%" : "0 auto",
            }}
          >
            <PinHelperText
              c_num={c_num}
              styles={styles}
              content={content}
              setOpenSupportDialog={setOpenSupportDialog}
            />
            {content?.acc_acc_pin && (
              <Typography
                sx={{
                  fontFamily: "var(--font_family_Regular)",
                  fontWeight: "var(--font_weight_0)",
                  fontSize: "14px",
                  lineHeight: "25px",
                  "& a": {
                    fontWeight: "var(--font_weight_1)",
                    color: "var(--primary_color)",
                    textDecoration: "none",
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: content?.acc_acc_pin,
                }}
              />
            )}
          </Box>
        )}
        {currentNum && (
          <Box width={{ xs: "90%", sm: "45%" }} m="0 auto">
            <AccountPinHelperText
              currentOperator={currentOperator}
              styles={styles}
              setOpenSupportDialog={setOpenSupportDialog}
              {...props}
            />
          </Box>
        )}
        <NewNumberModal
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          content={content}
          zipCodeformik={props.zipCodeformik}
          zipcodeChangeHandler={props.zipcodeChangeHandler}
          {...props}
        />
      </Box>
    </>
  );
};
export default T6ActivationStep2;
